package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_02_21_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-02-21")
@Composable
public fun Log_2026_02_21(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Sailfish, Sunburn, and Sudden Demons",
        ogTitle = "Sailfish, Sunburn, and Sudden Demons",
        date = LocalDate(2_026, 2, 21),
        ogDescription = "Captain Leah wanted a quiet supply run. Instead she got Merrow boarders, airborne demons, and Dirk’s ongoing campaign to impress her.",
        ogImage = "images/sailfishSurprise_preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A hand-drawn illustration of a sailfish, a sailboat, and a winged demon creature on the sea.",
    ) {
        SessionDayHeader(dayId = "shimmer-13", dateString = "Shimmer 13")
        Log_2026_02_21_Day_1()
        SessionMediaItem(
            image = "images/sailfishSurprise.webp",
            linkImage = "images/sailfishSurprise.webp",
            description = "A hand-drawn illustration of a sailfish, a sailboat, and a winged demon creature on the sea.",
            width = 4_032,
            height = 3_024,
        )
    }
}
